import { call, put } from "redux-saga/effects";
import { categoryService } from "../services/categoryService";
import { categoryConstants } from "../actions/constants/categoryContansts";
import { commonConstants } from "../actions/constants/commonConstants";
import { act } from "react";

function* getCategory(action: any): any {
  try {
    const response = yield call(categoryService.getCategory, action.payload);
    if (response.success) {
      yield put({ type: categoryConstants.getCategorySuccess, payload: response.resultObject });
    } else {
      yield put({ type: categoryConstants.getCategoryFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: categoryConstants.getCategoryFailure, payload: error });
  }
}

function* createCategory(action: any): any {
  try {
    const response = yield call(categoryService.createCategory, action.payload);
    if (response.success) {
      yield put({ type: categoryConstants.categoryCreateSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: categoryConstants.categoryCreateFailure, payload: response.errorMessage });
       yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: categoryConstants.categoryCreateFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* getCategoryParams(action: any): any {
  try {
    const response = yield call(categoryService.getCategoryParams, action.payload);
    if (response.success) {
      yield put({ type: categoryConstants.getCategoryParamsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: categoryConstants.getCategoryParamsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: categoryConstants.getCategoryParamsFailure, payload: error });
  }
}

function* deleteCategory(action: any): any {
  try {
    const response = yield call(categoryService.deleteCategory, action.payload);
    if (response.success) {
      yield put({ type: categoryConstants.categoryDeleteSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: categoryConstants.categoryDeleteFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: categoryConstants.categoryDeleteFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* toggleCategory(action: any): any {
  try {
    const response = yield call(categoryService.toggleCategory, action.payload);
    if (response.success) {
      yield put({ type: categoryConstants.categoryToggleSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: categoryConstants.categoryToggleFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: categoryConstants.categoryToggleFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* viewCategory(action: any): any {
  try {
    const response = yield call(categoryService.viewCategory, action.payload);
    if (response.success) {
      yield put({ type: categoryConstants.categoryViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: categoryConstants.categoryViewFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: categoryConstants.categoryViewFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

export const categorySaga = {
  getCategoryParams,
  createCategory,
  getCategory,
  toggleCategory,
  deleteCategory,
  viewCategory
}